import { useCallback } from 'react';

import { useScopedTranslate } from '@locale/translate';

import { usePermissions } from 'features/permissions';

import { useCanManageJobAccess } from './use-manage-job-access';

export function useDeleteApplicantsAccess() {
  const { t } = useScopedTranslate(locale);
  const { hasRolePermission } = usePermissions();
  const canManageJobAccess = useCanManageJobAccess();
  const creatorOrAdminOnly = t('creatorOrAdminOnly');

  return useCallback(
    (jobCreatedById: number | undefined) => {
      const isVisible = hasRolePermission('application:delete');
      const isDisabled = !canManageJobAccess(jobCreatedById);
      return {
        isVisible,
        isDisabled,
        tooltip: isVisible && isDisabled ? creatorOrAdminOnly : undefined,
      };
    },
    [hasRolePermission, canManageJobAccess, creatorOrAdminOnly],
  );
}

const locale = {
  en: {
    creatorOrAdminOnly: 'Only the job creator or an admin can delete applicants',
  },
  is: {
    creatorOrAdminOnly: 'Aðeins sá sem stofnaði starfið eða stjórnandi getur eytt umsækjendum',
  },
};
